module.exports = __webpack_public_path__ + "img/crkvaR.324818db.png";